import * as React from 'react';
import { connect } from 'react-redux';

import BooksOptionsList from '../../../../components/books/model1/forms/BooksOptionsList';
import { Option } from '../../../../interfaces/merchants/resources/books';

interface Props {
  options: Option[];
  checkedOptions: Option[];
  onClick: (options: Option[]) => void;
}

interface State {
  options: { [id: number]: Option };
}

const applyChange = (
  options: { [id: number]: Option },
  option: Option,
  checked: boolean,
): { [id: number]: Option } => {
  if (checked) {
    return { ...options, [option.id]: option };
  }
  const _options = { ...options };
  delete _options[option.id];
  return _options;
};

class InputBookingTargetOptionSelector extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { options: {} };
    this.handleClickOption = this.handleClickOption.bind(this);
  }

  public handleClickOption(e: React.ChangeEvent<HTMLInputElement>) {
    const { options, onClick } = this.props;
    const option = options.find(o => String(o.id) === e.currentTarget.value)!;
    const checked = e.currentTarget.checked;

    const newOptions = applyChange(this.state.options, option, checked);
    this.setState({ options: newOptions });
    onClick(Object.values(newOptions));
  }

  public render() {
    const { options, checkedOptions } = this.props;
    return (
      <BooksOptionsList
        options={options}
        checkedOptions={checkedOptions}
        onChange={this.handleClickOption}
      />
    );
  }
}

export default connect()(InputBookingTargetOptionSelector);
